var map = {
	"./arrow-left.svg": 307,
	"./arrow-right.svg": 308,
	"./carret-down.svg": 309,
	"./carret-left.svg": 310,
	"./carret-right.svg": 311,
	"./cross.svg": 312,
	"./email2.svg": 313,
	"./fork.svg": 314,
	"./gift-box.svg": 315,
	"./gift.svg": 316,
	"./logo-deuxpoints.svg": 317,
	"./mail.svg": 318,
	"./mail_icon.svg": 319,
	"./phone_icon.svg": 320,
	"./pin_icon.svg": 321,
	"./play.svg": 322,
	"./triangle-down.svg": 323,
	"./triangle-right.svg": 324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 306;